<template>
    <vx-prompt
        :title="title"
        :active.sync="serverDisconnected"
        prevent-close-on-accept
        persistent
        hide-close-button
    >
        <div class="flex justify-between items-center">
            <div>
                <strong>Please check the following:</strong>
                <ul>
                    <li>Internet connection</li>
                    <li>Try refreshing your browser</li>
                    <li>Wait 2 minutes (we might be running updates)</li>
                </ul>
                <br />
                <span> If these don't help, please shoot us a message </span>
                <!-- <vx-email value="dev-requests@compnow.com.au"></vx-email> -->
            </div>
            <img :src="imageSource" alt="Cloud God" height="200px" />
        </div>
    </vx-prompt>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'health-check-popup',
    data() {
        return {
            image: null
        }
    },
    computed: {
        ...mapGetters({
            isServerAvailable: 'connection/isServerAvailable'
        }),
        serverDisconnected() {
            if (process.env.NODE_ENV !== 'production') {
                return false
            }
            return !this.isServerAvailable
        },
        title() {
            return 'Maari Ma Unavailable'
        },
        imageSource() {
            return this.image && this.image.src
        }
    },
    methods: {
        cacheImage() {
            var img = new Image()
            img.src = require('../../assets/images/serverError.png')
            this.image = img
        }
    },
    mounted() {
        this.cacheImage()
    }
}
</script>

<style scoped>
li {
    font-size: 14px;
    margin-left: 10px;
    display: list-item;
    list-style-type: circle;
    list-style-position: inside;
}
</style>
